(function () {
  function isNearBottom(el, offset) {
    var rect = el.getBoundingClientRect();
    return rect.top < (window.innerHeight + (offset || 600));
  }

  async function loadNext(wrap) {
    if (!wrap || wrap.dataset.loading === '1') return;

    var nextUrl = wrap.getAttribute('data-next-url');
    if (!nextUrl) return;

    wrap.dataset.loading = '1';

    var loader = wrap.querySelector('.infinite-scroll__loader');
    if (loader) loader.hidden = false;

    try {
      var res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      var htmlText = await res.text();

      var temp = document.createElement('div');
      temp.innerHTML = htmlText;

      var newGrid = temp.querySelector('#product-grid');
      var productGrid = document.querySelector('#product-grid');

      if (!newGrid || !productGrid) {
        wrap.remove();
        return;
      }

      // Append only new product <li>
      Array.from(newGrid.children).forEach(function (item) {
        productGrid.appendChild(item);
      });

      // Update next url
      var newWrap = temp.querySelector('.infinite-scroll');
      var newNextUrl = newWrap && newWrap.getAttribute('data-next-url');

      if (newNextUrl) {
        wrap.setAttribute('data-next-url', newNextUrl);
      } else {
        wrap.remove(); // no more pages
      }
    } catch (e) {
      // stop on error
      // console.log(e);
      wrap.removeAttribute('data-next-url');
    } finally {
      wrap.dataset.loading = '0';
      if (loader) loader.hidden = true;
    }
  }

  function init() {
    var wrap = document.querySelector('.infinite-scroll');
    if (!wrap) return;

    // prevent double init
    if (wrap.dataset.init === '1') return;
    wrap.dataset.init = '1';

    function onScroll() {
      if (!wrap.isConnected) return;
      if (!wrap.getAttribute('data-next-url')) return;

      // If user is near bottom, load next
      if (isNearBottom(wrap, 800)) {
        loadNext(wrap);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // initial check (sometimes page already near bottom)
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', init);

  // Dawn filters/sort replace DOM -> re-init
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  // Also re-init after facets updates
  document.addEventListener('facet:updated', function () {
    init();
  });
})();